import React from 'react';
import { Column } from '../../hooks/useTablePages';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { UserItem, UserItemAdmin } from './Users';
import StatusDot, { StatusStyle } from '../../components/Status/StatusDot';

const columns: Column[] = [
  {
    header: 'Status',
    id: 'status',
    accessor: (row: UserItem | UserItemAdmin) => {
      const style: StatusStyle = row.status === 'ACTIVE' ? 'success' : 'error';

      return <StatusDot status={style} mr="1" />;
    },
    stringAccessor: (row: any): string => {
      return constantToLabel(row.status);
    },
    width: 80,
  },
  {
    header: 'Email',
    accessor: 'email',
    width: 300,
  },
  {
    header: 'Name',
    accessor: 'profile.name',
    width: 350,
  },
  {
    header: 'Role(s)',
    id: 'roles',
    sortable: false,
    accessor: (row: UserItem | UserItemAdmin): string => {
      if (!row.roles) return '';
      return (row.roles as any[])
        .map((role: string | { companyProfileId: string; role: string }) =>
          typeof role === 'string'
            ? constantToLabel(role)
            : constantToLabel(role.role)
        )
        .join(', ');
    },
    width: 300,
  },
];

export default columns;
